import { FC, ReactNode, useCallback } from 'react';
import axios, { AxiosRequestConfig } from 'axios';

import { AxiosContext } from './AxiosContext';
import { backendDataRequest as innerBackendDataRequest } from './backendDataRequests';
import { backendDataPeriodCachingRequest as innerBackendDataPeriodCaching } from './backendDataPeriodCachingRequest';

interface AxiosProviderProps {
  baseURL: string;
  children: ReactNode;
  userManager: any;
}

export const AxiosProvider: FC<AxiosProviderProps> = ({
  baseURL,
  children,
  userManager,
}) => {
  const request = useCallback(
    async (url = 'data', config?: AxiosRequestConfig) => {
      const client = axios.create({ baseURL });
      const user = await userManager.getUser();
      if (user && user.access_token) {
        client.defaults.headers.common.Authorization = `Bearer ${user.access_token}`;
      }
      return client(url, config);
    },
    [baseURL, userManager]
  );

  const backendDataRequest = useCallback(
    async (url = 'data', config?: AxiosRequestConfig) =>
      innerBackendDataRequest(request, url, config),
    [request]
  );

  const backendDataPeriodCachingRequest = useCallback(
    async (url = 'data', config?: AxiosRequestConfig) =>
      innerBackendDataPeriodCaching(request, url, config),
    [request]
  );

  return (
    <AxiosContext.Provider
      value={{
        request,
        backendDataRequest,
        backendDataPeriodCachingRequest,
      }}
    >
      {children}
    </AxiosContext.Provider>
  );
};
